import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputMaskModule } from 'primeng/inputmask';

import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { NoResultComponent } from 'src/app/shared/components/no-result/no-result.component';
import { MessageComponent } from 'src/app/shared/components/message/message.component';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { ConfirmationComponent } from 'src/app/shared/dialog/confirmation/confirmation.component';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';
import { AgeVerificationDialogComponent } from 'src/app/shared/dialog/age-verification-dialog/age-verification-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NoResultComponent,
    MessageComponent,
    UserProfileComponent,
    ConfirmationComponent,
    LoaderComponent,
    AgeVerificationDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    InputMaskModule,
    DropdownModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NoResultComponent,
    MessageComponent,
    UserProfileComponent,
    ConfirmationComponent,
    LoaderComponent
  ]
})
export class SharedModule { }
